import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'highlightKeyword' })
export class KeywordHighlighter implements PipeTransform {

    transform(value: string, keyword: string) {
        return value.replace(new RegExp(keyword, 'gi'), '<span class="nav--mega__highlight">$&</span>');
    }

}
